import generalStrings from 'modules/general/strings';
import SectionDivider from 'modules/common/components/SectionDivider';
import Error from 'assets/images/error.png';

import { Wrapper, Image, Title, SubTitle } from './RegisterError.style';

const RegisterError = () => (
  <Wrapper>
    <Image src={Error} />
    <SectionDivider gap={19} />
    <Title>{generalStrings.registerForm.formErrorTitle}</Title>
    <SectionDivider gap={8} />
    <SubTitle>{generalStrings.registerForm.formErrorSubTitle}</SubTitle>
  </Wrapper>
);

export default RegisterError;
